import BreadCrumbs from "../../../breadcrumbs"
import ProfileLogo from "../../../profile-logo"
import { PendingSubscriptionFull } from "../../../../../types"
import { LightBtn } from "../../../buttons"
import { X, Pencil } from "lucide-react"
import DreamRateStatus from "../../table/cells/engagements/dream-rate-status"
import { getPendingSubscriptionStatus } from "../../../../utils/dream-rate"

interface Props {
  data: PendingSubscriptionFull
  bankName?: string
  onUpdateTrigger: () => void
  onCancel: () => void
}

const DreamRateDetailsHeader = ({
  data,
  bankName,
  onUpdateTrigger,
  onCancel
}: Props) => {
  return (
    <>
      <BreadCrumbs
        pages={[
          {
            name: "Dream rate",
            href: "/engagements?tab=dreamRate",
            current: false
          },
          {
            name: data.email,
            href: "#",
            current: true
          }
        ]}
      />
      <div className="pt-6 pb-4 block sm:flex items-center justify-between">
        <div className="flex items-center">
          <ProfileLogo
            label={`${data.first_name.charAt(0)}${data.last_name.charAt(0)}`}
            className="w-16 h-16 shrink-0"
          />
          <div className="pl-4">
            <div className="flex items-center flex-wrap">
              <div className="font-bold text-xl mr-2">{data.email}</div>
              <DreamRateStatus status={getPendingSubscriptionStatus(data)} />
            </div>
            <div className="text-base pt-1">
              {data.first_name} {data.last_name}
              <span className="text-gray-400 inline-block mx-1">&bull;</span>
              {bankName}
            </div>
          </div>
        </div>
        <div className="flex items-center pl-0 mt-4 sm:mt-0 gap-2">
          <LightBtn onClick={onUpdateTrigger}>
            <Pencil size={16} className="mr-2" /> Edit
          </LightBtn>
          <LightBtn onClick={onCancel}>
            <X size={16} className="mr-2" /> Cancel
          </LightBtn>
        </div>
      </div>
    </>
  )
}

export default DreamRateDetailsHeader
